require('backbone-computedfields');
require('../../vendor/jquery.payment.extended.js');
var Moment = require('moment');
var EntitiesBase = require('./base');
var DateUtils = require('../utils/dates');
var Obscura = require('backbone.obscura');
var lsCache = require('lscache');
var LS_CACHE_CART_ID = 'farm_cart_collection_3';
var CACHE_TIMEOUT = 14400000;
var STANDARD_GST_MULTIPLIER = 0.05;
var CUSTOMER_TOTAL_PER_ORDER_CANNABIS_WEIGHT = 30; // 30 grams
var validationUtils = require('./validation');
var StringUtils = require('../utils/strings');

var cartCommonMixin = {
    addCartItem: function (filterLocation, userId, variantModel, menuItemModel) {
      var imageUrl = null;
      var cartCount;
      if (menuItemModel.get('images').length > 0) {
        var images = menuItemModel.get('images');
        var primaryImage = images.findWhere({ is_primary: '1' });
        if (primaryImage) {
            imageUrl = primaryImage.get('thumb_url');
        } else {
            imageUrl = images.at(0).get('thumb_url');
        }
      }
      var existingCartItem = this.findWhere({
        variant_id: variantModel.get('id'),
        location: filterLocation,
        user_id: userId
      });
      if (existingCartItem) {
        // up the cart count....
        cartCount = parseInt(existingCartItem.get('cartCount'));
        cartCount = cartCount += 1;
        existingCartItem.set('cartCount', cartCount);
      } else {
        cartCount = 1;
        this.add(new CartItemModel({
          title: menuItemModel.get('title'),
          quantity: variantModel.get('quantity'),
          weight: variantModel.get('weight'),
          on_sale: variantModel.get('on_sale'),
          sale_price: variantModel.get('sale_price'),
          price: variantModel.get('price'),
          mix_match_codes: variantModel.get('mix_match_codes'),
          long_descr_pos: variantModel.get('long_descr_pos'),
          promotion_headline: variantModel.get('promotion_headline'),
          sale_min_qty: variantModel.get('sale_min_qty'),
          sale_min_qty_discount: variantModel.get('sale_min_qty_discount'),
          variant_id: variantModel.get('id'),
          product_id: variantModel.get('product_id'),
          vendor_name: menuItemModel.get('vendor_name'),
          id_pos: variantModel.get('id_pos'),
          slug: menuItemModel.get('slug'),
          thumb_url: imageUrl,
          user_id: userId,
          location: filterLocation,
          cartCount: cartCount
        }));
      }
    },
    itemsByUserLocation: function (filterLocation, userId, updateSubTotalSkip) {
      var cart_items = new Obscura(
          this
      );
      cart_items.filterBy('userLocation', function(model) {
        if (userId === model.get('user_id') && filterLocation === model.get('location')) {
          return true;
        } else {
          return false;
        }
      });

      if (updateSubTotalSkip !== null && updateSubTotalSkip === true) {
        cart_items.each(function (model) {
          model.updateSubTotal(filterLocation, userId);
        });
      }

      return cart_items;
    },
    moveCartItemsToLocation: function (userId, currentLocation, requestedLocation) {
      var self = this;
      var $deferred = $.Deferred();

      // get current location cart items...
      var currentCartItems = this.itemsByUserLocation(currentLocation, userId);

      //clear destination cart items
      this.clearCart(requestedLocation, userId);

      // loop through and move to new location
      currentCartItems.each(function (model) {
        var modelJSON = model.toJSON();
        delete modelJSON.id;
        modelJSON.location = requestedLocation;
        self.add(new CartItemModel(modelJSON));
      });

      //clear current once moved
      this.clearCart(currentLocation, userId);

      $deferred.resolve(this.itemsByUserLocation(requestedLocation, userId));
      return $deferred.promise();
    },
    totalCountByUserLocation: function (filterLocation, userId) {
      var count = 0;
      this.each(function (model) {
        if (userId === model.get('user_id') && filterLocation === model.get('location')) {
          count += parseInt(model.get('cartCount'));
        }
      });
      return count;
    },
    totalCostByUserLocation: function (userId, filterLocation, filterLocationDetails) {
      var subTotal = 0;
      var total = 0;
      var tax = 0;
      var taxGST = 0;
      var taxPST = 0;
      var groupDiscounts = 0;
      var depositTotal = 0;
      var extraDiscount = 0;
      var deliveryTotal = 0;
      var tipTotal = 0;
      var tipPercentage = 0;

      this.each(function (model) {
        if (userId === model.get('user_id') && filterLocation === model.get('location')) {
          var itemSubTotal = model.getSubTotal(filterLocation, userId);
          subTotal += itemSubTotal.item_sub_total;
          depositTotal += itemSubTotal.deposit_cost_total;
          groupDiscounts += itemSubTotal.itemGroupDiscount;
          taxGST += itemSubTotal.total_tax_gst;
          taxPST += itemSubTotal.total_tax_pst;
        }
      });

      if (this.deliveryModel.get('deliveryMethod') == 'local_delivery') {
          var basicDeliveryCost;
          if (!filterLocationDetails.get('delivery_fee')) {
            basicDeliveryCost = 0;
          } else {
            basicDeliveryCost = parseFloat(filterLocationDetails.get('delivery_fee'));
          }

          deliveryTotal += basicDeliveryCost;
          taxGST += (deliveryTotal * STANDARD_GST_MULTIPLIER);

          if (this.deliveryModel.get('deliveryTipPercentage') !== null) {
            tipPercentage = parseFloat(this.deliveryModel.get('deliveryTipPercentage'));
          } else {
            tipPercentage = parseFloat(filterLocationDetails.get('default_tip')); 
          }

      } // end if local_delivery

      // round the tax at the end and calculate the total
      tax = (Math.round(taxGST * 100) / 100) + (Math.round(taxPST * 100) / 100);
      total = subTotal + tax + depositTotal + deliveryTotal;

      tipTotal = Math.round((total * tipPercentage) * 100) / 100;

      total += tipTotal;

      return {
        subTotal: subTotal,
        groupDiscounts: groupDiscounts,
        depositTotal: depositTotal,
        deliveryTotal: deliveryTotal,
        tipTotal: tipTotal,
        tipPercentage: tipPercentage,
        tax: tax,
        taxGST: taxGST,
        taxPST: taxPST,
        total: total
      };
    },
    updateSubTotals: function (filterLocation, userId) {
      this.each(function (model) {
        if (userId === model.get('user_id') && filterLocation === model.get('location')) {
          model.updateSubTotal(filterLocation, userId);
        }
      });
      return this;
    },
    totalCartWeight: function (options) {
      var options = _.defaults(
          options || {},
          {
              filterLocation: null,
              userId: null,
              totalCannabisWeightAllowed: CUSTOMER_TOTAL_PER_ORDER_CANNABIS_WEIGHT
          }
      );

      var totalWeight = 0;
      this.each(function (model) {
        if (options.userId === model.get('user_id') && options.filterLocation === model.get('location')) {
          var weight = parseFloat(model.get('weight'));
          if (weight !== null && weight !== 0 && !isNaN(weight)) {
            totalWeight += parseFloat(model.get('cartCount')) * weight;
          }
        }
      });

      // round to two decimal places...
      totalWeight = +(Math.round(totalWeight + 'e+2')  + 'e-2');
      var weightError = false;
      var weightOver = 0;
      if (totalWeight > options.totalCannabisWeightAllowed) {
        weightError = true;
        weightOver = totalWeight - options.totalCannabisWeightAllowed;
      }

      lsCache.set(LS_CACHE_CART_ID, this.toJSON(), CACHE_TIMEOUT);

      return {
        error: weightError,
        totalWeight: totalWeight,
        weightOver: weightOver
      };
    },
    cleanupErrors: function () {
      this.each(function (model) {
        model.set('error', false);
        model.set('actualCount', null);
        model.set('code', null);
      });
    },
    customerBrowserDetails: function () {
      var browserTime = new Date();
      return {
        colorDepth: screen.colorDepth,
        javaEnabled: navigator.javaEnabled(),
        browserLanguage: navigator.language,
        screenHeight: screen.height,
        screenWidth: screen.width,
        userAgent: navigator.userAgent,
        browserTimezoneZoneOffset: browserTime.getTimezoneOffset()
      }
    },
    submitOrder: function(userId, filterLocation, filterLocationDetails) {
      var self = this;
      var $deferred = $.Deferred();
      var order_cost = this.totalCostByUserLocation(userId, filterLocation, filterLocationDetails);
      var payment_method = this.paymentModel.get('paymentMethod');
      var delivery_method = this.deliveryModel.get('deliveryMethod');

      var cartGiftModel = null;
      if (farmacy.settings.giftEnabled) {
        cartGiftModel = this.paymentModel.get('cartGiftModel').toJSON();
      }

      var deliveryAddressModel = this.deliveryModel.get('cartDeliveryAddressModel');
      if (deliveryAddressModel !== null) {
        deliveryAddressModel = deliveryAddressModel.toJSON();
      }

      var localDeliveryDetails = null;

      if (delivery_method == 'local_delivery') {
        
        var serverUnixTime = moment().unix() + filterLocationDetails.get('server_client_time_offset');
        
        this.deliveryModel.set('deliveryDate', DateUtils.getFormattedTimestamp(serverUnixTime, {
                format: 'MMMM Do, YYYY'
        }));
        
        this.deliveryModel.set('deliveryTime', serverUnixTime);

        this.deliveryModel.set('deliveryTimeReadable', DateUtils.getFormattedTimestamp(serverUnixTime, {
                format: 'h:mm:ss a'
        }));
        
        if (filterLocationDetails.get('delivery_to_minutes')) {
           this.deliveryModel.set('deliveryWindowMinutes', filterLocationDetails.get('delivery_to_minutes'));
        }

        localDeliveryDetails = {
          deliveryTime: this.deliveryModel.get('deliveryTime'),
          deliveryTimeReadable: this.deliveryModel.get('deliveryTimeReadable'),
          deliveryTimeStartUnix: this.deliveryModel.get('deliveryTimeStartUnix'),
          deliveryTimeEndUnix: this.deliveryModel.get('deliveryTimeEndUnix'),
          deliveryWindowMinutes: this.deliveryModel.get('deliveryWindowMinutes'),
          deliveryDate: this.deliveryModel.get('deliveryDate'),
          deliveryNotes: this.deliveryModel.get('deliveryNotes'),
          deliveryPhone: this.deliveryModel.get('deliveryPhone')
        };
      }

      Backbone.Radio.channel('global')
          .request('ajax', 'farmacyajaxv2-ordercartitems', {
              location_slug: filterLocation,
              user_id: userId,
              subTotal: order_cost.subTotal,
              tax: order_cost.tax,
              taxGST: order_cost.taxGST,
              taxPST: order_cost.taxPST,
              depositTotal: order_cost.depositTotal,
              total: order_cost.total,
              tip_total: order_cost.tipTotal,
              tip_percentage: order_cost.tipPercentage,
              delivery_total: order_cost.deliveryTotal,
              delivery_method: delivery_method,
              payment_method: payment_method,
              cart_items: this.itemsByUserLocation(filterLocation, userId).toJSON(),
              gift_details: cartGiftModel,
              local_delivery_details: localDeliveryDetails,
              delivery_address: deliveryAddressModel
          })
          .success(function(response) {
              $deferred.resolve(response);
          })
          .fail(function(error) {
              $deferred.reject();
          });
      return $deferred.promise();
    },
    payOrder: function(options) {
      var three_d_secure_trans = farmacy.settings.payments.threeDSecureByLocation[options.filterLocation];
      if (three_d_secure_trans == true) {
        return this.payOrder3dSecure(options);
      } else {
        return this.payOrderLegacy();
      }
    },
    payOrderLegacy: function() {
      var self = this;
      var $deferred = $.Deferred();
      if (this.paymentModel.get('currentOrder')) {

        Backbone.Radio.channel('global')
            .request('ajax', 'farmacyajaxv2-orderpay', {
                order_id: this.paymentModel.get('currentOrder').get('order_id'),
                payment_method: this.paymentModel.get('paymentMethod'),
                payment_method_details: this.paymentModel.get('paymentCreditCardModel').toJSON(),
                customer_browser_details: this.customerBrowserDetails(),
                three_d_secure_trans: false
            })
            .success(function(response) {
                if (response.error == false && response.message.order_id) {
                  // clear card payment_method_details...
                  self.paymentModel.set('paymentCreditCardModel', new PaymentCreditCardModel());
                  self.paymentModel.set('cartGiftModel', new CartGiftModel());
                } else {
                  // error specific to field
                  if (response.errorField !== null) {
                    var paymentCreditCardModel = self.paymentModel.get('paymentCreditCardModel');
                    if (paymentCreditCardModel) {
                      paymentCreditCardModel.set('cc_security_code', null);
                      if (response.errorField === 'cc_number') {
                        // clear all card data when declined, usually a smell for fraud
                        self.clearCardDetails();
                      }
                    }
                  }
                }
                $deferred.resolve(response);
            })
            .fail(function(error) {
                $deferred.reject();
            });
      } else {
        $deferred.reject();
      }
      return $deferred.promise();
    },
    payOrder3dSecure: function(options) {
      var self = this;
      var $deferred = $.Deferred();
      var _appChannel = options._appChannel;

      if (this.paymentModel.get('currentOrder')) {
        var data = {
                order_id: this.paymentModel.get('currentOrder').get('order_id'),
                payment_method: this.paymentModel.get('paymentMethod'),
                payment_method_details: this.paymentModel.get('paymentCreditCardModel').toJSON(),
                customer_browser_details: this.customerBrowserDetails(),
                three_d_secure_trans: true,
                three_d_secure_trans_step: 'challenge'
        };
        var handleError = function (response) {
          // error specific to field
          if (response.errorField !== null) {
            var paymentCreditCardModel = self.paymentModel.get('paymentCreditCardModel');
            if (paymentCreditCardModel) {
              paymentCreditCardModel.set('cc_security_code', null);
              if (response.errorField === 'cc_number') {
                // clear all card data when declined, usually a smell for fraud
                self.clearCardDetails();
              }
            }
          }
          $deferred.resolve(response);
        };
        Backbone.Radio.channel('global')
            .request('ajax', 'farmacyajaxv2-orderpay', data)
            .success(function(challengeResponse) {
              if (challengeResponse.error == false && challengeResponse.type == 'three_d_secure') {
                // clear payment data
                self.paymentModel.set('paymentCreditCardModel', new PaymentCreditCardModel());
                self.paymentModel.set('cartGiftModel', new CartGiftModel());
                $deferred.resolve({
                  error: false,
                  data: {
                    type: 'three_d_secure',
                    challengeUrl: challengeResponse.data.challengeUrl,
                    challengeData: challengeResponse.data.challengeData
                  }
                });
              }  else if (challengeResponse.error == false  && challengeResponse.message.order_id) {
                // frictionless response...
                self.paymentModel.set('paymentCreditCardModel', new PaymentCreditCardModel());
                self.paymentModel.set('cartGiftModel', new CartGiftModel());
                $deferred.resolve(challengeResponse);
              } else {
                handleError(challengeResponse);
              }
            })
            .fail(function(error) {
                $deferred.reject();
            });
      } else {
        $deferred.reject();
      }
      return $deferred.promise();
    },
    clearCardDetails: function () {
      var paymentCreditCardModel = this.paymentModel.get('paymentCreditCardModel');
      if (paymentCreditCardModel) {
        paymentCreditCardModel.set('cc_name_on_card', null);
        paymentCreditCardModel.set('cc_number', null);
        paymentCreditCardModel.set('cc_expiry_date', null);
        paymentCreditCardModel.set('cc_security_code', null);
        paymentCreditCardModel.set('cc_postal_code', null);
      }
    },
    clearCart: function (filterLocation, userId) {
      var self = this;
      this.itemsByUserLocation(filterLocation, userId).each(function () {
        self.findWhere({
          location: filterLocation,
          user_id: userId
        }).destroy();
      })
    },
    checkCartItemsForPriceChanges: function (filterLocation, userId) {
      var self = this;
      var $deferred = $.Deferred();
      var errors = [];

      if (this.itemsByUserLocation(filterLocation, userId).length === 0) {
        $deferred.resolve();
      }

      Backbone.Radio.channel('global')
          .request('ajax', 'farmacyajaxv2-verifycartprices', {
              location_slug: filterLocation,
              cart_items: this.itemsByUserLocation(filterLocation, userId).toJSON()
          })
          .success(function(response) {
              var changeCount = 0;
              response.variants.forEach(function (variant, index) {
                if (variant.on_sale == '1') {
                  variant.on_sale = true;
                } else {
                  variant.on_sale = false;
                }

                var modelMatch = self.findWhere(
                  {
                    variant_id: variant.id,
                    user_id: userId,
                    location: filterLocation
                  });
                if (modelMatch) {
                  if (modelMatch.get('price') !== variant.price) {
                    modelMatch.set('price', variant.price);
                    changeCount+=1;
                  }

                  if (modelMatch.get('sale_price') !== variant.sale_price) {
                    modelMatch.set('sale_price', variant.sale_price);
                    changeCount+=1;
                  }

                  if (modelMatch.get('on_sale') !== variant.on_sale) {
                    modelMatch.set('on_sale', variant.on_sale);
                    changeCount+=1;
                  }

                  if (modelMatch.get('weight') !== variant.weight) {
                    modelMatch.set('weight', variant.weight);
                    changeCount+=1;
                  }

                  if (modelMatch.get('tax_code') !== variant.tax_code) {
                    modelMatch.set('tax_code', variant.tax_code);
                    changeCount+=1;
                  }

                  if (modelMatch.get('tax_code_pst_percentage') !== variant.tax_code_pst_percentage) {
                    modelMatch.set('tax_code_pst_percentage', variant.tax_code_pst_percentage);
                    changeCount+=1;
                  }

                  if (modelMatch.get('tax_code_gst_percentage') !== variant.tax_code_gst_percentage) {
                    modelMatch.set('tax_code_gst_percentage', variant.tax_code_gst_percentage);
                    changeCount+=1;
                  }

                  if (modelMatch.get('tax_code_gst_on_pst') !== variant.tax_code_gst_on_pst) {
                    modelMatch.set('tax_code_gst_on_pst', variant.tax_code_gst_on_pst);
                    changeCount+=1;
                  }

                  if (modelMatch.get('tax_code_flat_fee') !== variant.tax_code_flat_fee) {
                    modelMatch.set('tax_code_flat_fee', variant.tax_code_flat_fee);
                    changeCount+=1;
                  }

                  if (modelMatch.get('deposit_cost') !== variant.deposit_cost) {
                    modelMatch.set('deposit_cost', variant.deposit_cost);
                    changeCount+=1;
                  }

                  if (modelMatch.get('long_descr_pos') !== variant.long_descr_pos) {
                    modelMatch.set('long_descr_pos', variant.long_descr_pos);
                    changeCount+=1;
                  }

                  if (modelMatch.get('mix_match_codes') !== variant.mix_match_codes) {
                    modelMatch.set('mix_match_codes', variant.mix_match_codes);
                    changeCount+=1;
                  }

                  if (modelMatch.get('sale_min_qty') !== variant.sale_min_qty) {
                    modelMatch.set('sale_min_qty', variant.sale_min_qty);
                    changeCount+=1;
                  }

                  if (modelMatch.get('sale_min_qty_discount') !== variant.sale_min_qty_discount) {
                    modelMatch.set('sale_min_qty_discount', variant.sale_min_qty_discount);
                    changeCount+=1;
                  }

                  if (modelMatch.get('promotion_headline') !== variant.promotion_headline) {
                    modelMatch.set('promotion_headline', variant.promotion_headline);
                    changeCount+=1;
                  }

                  if (modelMatch.get('sub_category_id_pos') !== variant.sub_category_id_pos) {
                    modelMatch.set('sub_category_id_pos', variant.sub_category_id_pos);
                    changeCount+=1;
                  }

                  if (modelMatch.get('category_id_pos') !== variant.category_id_pos) {
                    modelMatch.set('category_id_pos', variant.category_id_pos);
                    changeCount+=1;
                  }

                }
              });

              if (changeCount > 0) {
                self.updateSubTotals(filterLocation, userId);
                lsCache.set(LS_CACHE_CART_ID, self.toJSON(), CACHE_TIMEOUT);
              }

              $deferred.resolve({
                changeCount: changeCount
              });
          })
          .fail(function() {
              $deferred.reject();
          });
      return $deferred.promise();
    },
    validateCartContents: function(userId, filterLocation, filterLocationDetails) {
        var self = this;
        var $deferred = $.Deferred();
        var errors = null;

        if (this.itemsByUserLocation(filterLocation, userId).length === 0) {
          errors.push({
            code: 'cartempty'
          })
          $deferred.resolve({
            errors: errors
          });
        }

        function parseInventoryErrors(response) {
            self.cleanupErrors();
            errors = response.pos_verify_inventory_errors;
            if (errors == null || errors.length == 0) {
              errors = response.local_verify_inventory_errors;
            }

            if (errors !== null) {
              errors.forEach(function (error, index) {
                var modelMatch = self.findWhere(
                  {
                    variant_id: error.variant_id,
                    user_id: userId,
                    location: filterLocation
                  });
                if (modelMatch) {
                    modelMatch.set('error', true);
                    modelMatch.set('actualCount', parseInt(error.actualCount));
                    modelMatch.set('code', error.code);
                }
              });
            } else {
              errors = [];
            }
            var totalCannabisWeightAllowed = CUSTOMER_TOTAL_PER_ORDER_CANNABIS_WEIGHT;
            if (totalCannabisWeightAllowed <= 0) {
              totalCannabisWeightAllowed = 0;
            }
            var totalCartWeight = self.totalCartWeight({
              filterLocation: filterLocation,
              userId: userId,
              totalCannabisWeightAllowed: totalCannabisWeightAllowed
            });

            if (totalCartWeight.error === true) {

              var message = null;
              if (totalCannabisWeightAllowed !== CUSTOMER_TOTAL_PER_ORDER_CANNABIS_WEIGHT) {
                message = 'You can only order a total 30 grams at a time. This includes previous orders not picked up or delivered. Currently your profile has exceeded the 30 gram order limit by ' + totalCartWeight.weightOver + ' grams. Please remove items from this order'
              }

              errors.push({
                code: 'overlimit',
                message: message
              });
            }

            if (response.paymentMethods !== null) {

              var paymentMethodAvailable = true;

              if (self.paymentModel.get('paymentMethod') == 'credit' && !response.paymentMethods.creditCardPaymentEnabled) {
                paymentMethodAvailable = false;
              }

              if (self.paymentModel.get('paymentMethod') == 'interac' && !response.paymentMethods.interacPaymentEnabled) {
                paymentMethodAvailable = false;
              }

              /*
              // leaving this here in case we want to pivot on the returned settings change, in the case of settings changing
              // when a user is in the checkout flow.
              farmacy.settings.payments.interacPaymentEnabled = response.paymentMethods.interacPaymentEnabled;
              farmacy.settings.payments.creditCardPaymentEnabled = response.paymentMethods.creditCardPaymentEnabled;
              */

              if (!paymentMethodAvailable) {
                errors.push({
                  code: 'paymentmethod',
                  message: 'The payment method you have selected is currently unavailable at this time.'
                });
              }
            }

            // if its local delivery validate address and delivery time.
            if (self.deliveryModel.get('deliveryMethod') == 'local_delivery') {
              
              var cartdeliveryAddressModel = self.deliveryModel.get('cartDeliveryAddressModel');
              var postalCodeError = false;
              if (cartdeliveryAddressModel.get('local_delivery_confirmed_farm_location_slug') !== filterLocation ||
                cartdeliveryAddressModel.get('local_delivery_postal_code_verified') == null ||
                cartdeliveryAddressModel.get('local_delivery_postal_code_verified') !== cartdeliveryAddressModel.get('local_delivery_postal_code')) {
                postalCodeError = true;
              }
              if (postalCodeError == true) {
                errors.push({
                  code: 'postalcode',
                  message: 'Postal code must be verified.'
                });
              }

              var addressError = false;
              if (cartdeliveryAddressModel.get('local_delivery_street_address') == null ||
                cartdeliveryAddressModel.get('local_delivery_street_address').length < 1) {
                errors.push({
                  code: 'deliveryaddress',
                  message: 'Please provide a valid address.'
                });
              }
              
              // basic length validation on phone number, pretty much just checking if its blank.
              if (self.deliveryModel.get('deliveryPhone') == null || self.deliveryModel.get('deliveryPhone').length < 7) {
                errors.push({
                  code: 'phone',
                  message: 'Please provide a valid phone number.'
                });
              }

              var deliveryMinimumCartTotal = 0;
              if (filterLocationDetails.get('delivery_min_dollar_amount')) {
                deliveryMinimumCartTotal = parseFloat(filterLocationDetails.get('delivery_min_dollar_amount'));
              }
              var order_cost = self.totalCostByUserLocation(userId, filterLocation, filterLocationDetails);
              if (order_cost.subTotal < deliveryMinimumCartTotal) {
                errors.push({
                  code: 'deliveryminimum',
                  message: 'For local delivery a minimum order of ' + StringUtils.currency(deliveryMinimumCartTotal) + ' before taxes and tip is required.'
                });
              }


              var deliveryErrorMessage = 'Delivery is unavailable at this time.'

              if(parseInt(filterLocationDetails.get('delivery_active')) == 0 || filterLocationDetails.get('delivery_active') == false) {
                errors.push({
                  code: 'deliveryunavailable',
                  message: deliveryErrorMessage
                });
              } else {
                
                // validate if delivery is still active, in the case that they have had the cart sitting open.
                if (!filterLocationDetails.isDeliveryAvailableAtCurrentTime().available) {
                  
                  var deliveryNextAvailable = filterLocationDetails.deliveryNextAvailable();
                  
                  if (deliveryNextAvailable.available) {
                    if (deliveryNextAvailable.isToday) {
                      deliveryNextAvailable.day = 'today';
                    } else {
                      deliveryNextAvailable.day = deliveryNextAvailable.day.charAt(0).toUpperCase() + deliveryNextAvailable.day.slice(1)
                    }
                  
                    deliveryErrorMessage += ' Delivery will be available again ' + 
                    deliveryNextAvailable.day + 
                    ' between ' + 
                    deliveryNextAvailable.startTime + 
                    ' and ' +
                    deliveryNextAvailable.endTime;

                    errors.push({
                      code: 'deliveryunavailable',
                      message: deliveryErrorMessage
                    });
                  }
                }
              }

            }// end if local_delivery
            
            $deferred.resolve({
              errors: errors
            });
        } // end parseInventoryErrors function...

        Backbone.Radio.channel('global')
        .request('ajax', 'farmacyajaxv2-verifycartitems', {
            location_slug: filterLocation,
            cart_items: this.itemsByUserLocation(filterLocation, userId).toJSON()
        })
        .success(function(response) {
            parseInventoryErrors(response);
        })
        .fail(function() {
            $deferred.reject();
        });

        return $deferred.promise();
    }
};


var CartItemModel = EntitiesBase.ModelBase.extend({
  defaults: {
    title: null,
    quantity: null,
    on_sale: null,
    sale_price: null,
    price: null,
    id: null,
    weight: null,
    product_id: null,
    variant_id: null,
    id_pos: null,
    thumb_url: null,
    user_id: null,
    error: false,
    actualCount: null,
    code: null
  },
  getPrice: function () {
    if (this.get('on_sale') === true && (this.get('sale_price') !== '0' && this.get('sale_price') !== '0.00' && this.get('sale_price') !== 0 && this.get('sale_price') !== 0.00)) {
      return parseFloat(this.get('sale_price'));
    } else {
      return parseFloat(this.get('price'));
    }
  },
  getTax: function (price) {
    var itemTax = 0;
    var gstPercentage = parseFloat(this.get('tax_code_gst_percentage'));
    var pstPercentage = parseFloat(this.get('tax_code_pst_percentage'));
    var itemTaxPST;
    var itemTaxGST;
    if (this.get('tax_code_gst_on_pst') === '1') {
      itemTaxPST = ( price ) * pstPercentage;
      itemTaxGST = ( price ) * gstPercentage;
      var gstOnPst = ( itemTaxPST * gstPercentage );
      itemTaxGST += gstOnPst;
      itemTax = itemTaxPST + itemTaxGST;
    } else {
      //itemTax = price * ( pstPercentage + gstPercentage );
      itemTaxPST = ( price ) * pstPercentage;
      itemTaxGST = ( price ) * gstPercentage;
      itemTax = itemTaxPST + itemTaxGST;
    }

    // add flat fee tax if any...
    itemTax += parseFloat(this.get('tax_code_flat_fee'));

    return {
      itemTotalTax: itemTax,
      itemTaxPST: itemTaxPST,
      itemTaxGST: itemTaxGST,
      itemBeverageFee: parseFloat(this.get('tax_code_flat_fee')), // beverage fee
    };
  },
  getSubTotal: function (userId, filterLocation, filterLocationDetails) {
    var self = this;
    var price = 0
    var itemDepositCost = 0;
    var saleMinQty = parseFloat(this.get('sale_min_qty'));

    var saleMinQtyDiscount;
    var itemGroupDiscountIsPercentage = false;

    // is the group discount a percentage...
    if (typeof this.get('sale_min_qty_discount') == 'string' && this.get('sale_min_qty_discount').includes('%')) {
      itemGroupDiscountIsPercentage = true;
      saleMinQtyDiscount = parseFloat(this.get('sale_min_qty_discount').replace('%', ''));
    } else {
      saleMinQtyDiscount = parseFloat(this.get('sale_min_qty_discount'));
    }

    var itemGroupDiscount = 0;
    var itemGroupDiscountSpread = 0;
    var itemMixMatchDiscountSpread = 0;

    var cartCount = parseFloat(this.get('cartCount'));

    if (cartCount >= saleMinQty) {
      if (itemGroupDiscountIsPercentage === true) {
        saleMinQtyDiscount = saleMinQtyDiscount / 100;
        // group percentage discount...
        itemGroupDiscount = (((Math.floor(cartCount / saleMinQty) * saleMinQty) * self.getPrice()) * saleMinQtyDiscount);
      } else {
        // if it's buy 3 get 5 off, it would take off five at 3, and then another five at six and so on...
        itemGroupDiscount = Math.floor(cartCount / saleMinQty) * (saleMinQtyDiscount);
      }

      // spread discount out for cart display...
      itemGroupDiscountSpread = (itemGroupDiscount / cartCount);
    }
    //[{"MIX_MATCH_COD":"DEALERPICK","PRC_BRK_DESCR":"Total quantity 2 => Price-1 - 5","DESCR":"MIX/MATCH $10 OFF 2x 3.5G/7G","SALE_MIN_QTY_DISCOUNT":5,"SALE_MIN_QTY":3}]
    if (this.get('mix_match_codes') !== null && this.get('mix_match_codes').length > 0) {
      var mix_match_codes_array = JSON.parse(this.get('mix_match_codes'));
      if (mix_match_codes_array && mix_match_codes_array.length) {
          _.each(mix_match_codes_array, function (code, key) {
              var codeItemCartCount = parseFloat(cartCount);
              self.collection.itemsByUserLocation(filterLocation, userId).each(function (model) {
                if (model.get('variant_id') !== self.get('variant_id')) {
                  // skip its the same variant
                  var model_mix_match_codes_array = JSON.parse(model.get('mix_match_codes'));
                  if (model_mix_match_codes_array && model_mix_match_codes_array.length) {
                    _.each(model_mix_match_codes_array, function (model_mix_match_code, key) {
                        if (model_mix_match_code.MIX_MATCH_COD == code.MIX_MATCH_COD) {
                          codeItemCartCount += parseFloat(model.get('cartCount'));
                        }
                    }); // end each model mix codes...
                  }
                } // if variant id's dont match
              }); // end looping through collection looking for match

              var mixMatchSaleMinQty = parseFloat(code.SALE_MIN_QTY);

              var mixMatchSaleMinQtyDiscount;

              var mixMatchDiscountIsPercentage = false;

              if (typeof code.SALE_MIN_QTY_DISCOUNT == 'string' && code.SALE_MIN_QTY_DISCOUNT.includes('%')) {
                mixMatchDiscountIsPercentage = true;
                mixMatchSaleMinQtyDiscount = parseFloat(code.SALE_MIN_QTY_DISCOUNT.replace('%', ''));
              } else {
                mixMatchSaleMinQtyDiscount = parseFloat(code.SALE_MIN_QTY_DISCOUNT);
              }
              var itemMixMatchDiscount = 0;
              if (codeItemCartCount >= mixMatchSaleMinQty ) {
                if (mixMatchDiscountIsPercentage === true) {
                  mixMatchSaleMinQtyDiscount = mixMatchSaleMinQtyDiscount / 100;
                  // percentage discount in groups...
                  itemMixMatchDiscount = (((Math.floor(codeItemCartCount / mixMatchSaleMinQty) * mixMatchSaleMinQty) * self.getPrice()) * mixMatchSaleMinQtyDiscount);
                } else {
                  // if it's buy 3 get 5 off, it would take off five at 3, and then another five at six and so on...
                  itemMixMatchDiscount = Math.floor(codeItemCartCount / mixMatchSaleMinQty) * (mixMatchSaleMinQtyDiscount);
                }

                // spread discount out for cart display...
                itemMixMatchDiscountSpread += (itemMixMatchDiscount / codeItemCartCount);
              }
          });
      }
    } // end if mix and match...

    price = this.getPrice();
    price = price - itemGroupDiscountSpread;
    price = price - itemMixMatchDiscountSpread;

    var itemTax = this.getTax(price);
    var itemTotalTax = itemTax.itemTotalTax;

    // to get savings... take original price minus price after deductions...
    var itemSavings = parseFloat(this.getPrice() - price);

    //deposit cost...
    itemDepositCost = parseFloat(this.get('deposit_cost'));

    return {
      deposit_cost_total: cartCount * itemDepositCost,
      group_discount_total: parseFloat(this.get('cartCount')) * itemSavings,
      total_tax: cartCount * itemTotalTax,
      total_tax_gst: cartCount * itemTax.itemTaxGST,
      total_tax_pst: cartCount * itemTax.itemTaxPST,
      item_tax: itemTotalTax,
      item_tax_pst: itemTax.itemTaxPST,
      item_tax_gst: itemTax.itemTaxGST,
      item_sub_total: parseFloat(this.get('cartCount')) * parseFloat(price),
      item_total: (cartCount * (price + itemTotalTax + itemDepositCost)),
      itemDepositCost: itemDepositCost
    }
  },
  updateSubTotal: function (filterLocation, userId) {
    var subTotal = this.getSubTotal(filterLocation, userId);
    this.set('deposit_cost_total', subTotal.deposit_cost_total);
    this.set('group_discount_total', subTotal.group_discount_total);
    this.set('total_tax', subTotal.total_tax);
    this.set('item_total', subTotal.item_total);
    this.set('total_tax_gst', subTotal.total_tax_gst);
    this.set('total_tax_pst', subTotal.total_tax_pst);
    this.set('item_sub_total', subTotal.item_sub_total);
  }
});

var CartCollection = EntitiesBase.CollectionBase.extend({
  model: CartItemModel
});

_.extend(CartCollection.prototype, cartCommonMixin);

var cartGiftValidationMixin = {
    gift_receiver_name: {
        required: true,
        msg: validationUtils.getIsRequiredMessageForFieldName('Name')
    },
    gift_receiver_email: {
        required: true,
        msg: validationUtils.getIsRequiredMessageForFieldName('Email')
    }
  };

var CartGiftModel = EntitiesBase.ModelBase.extend({
    constructor: function(attrs, options) {
        EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
    },
    validation: {},
    validationFields: function () {
      var fields = [
          'gift_receiver_name',
          'gift_receiver_email'
      ];
      return fields;
    },
    shouldValidateGiftForm: function () {
      if (this.get('gift_receiver_name') || this.get('gift_receiver_email') || this.get('gift_receiver_message')) {
        return true;
      }
    },
    defaults: {
      gift_receiver_name: null,
      gift_receiver_email: null,
      gift_receiver_message: null
    }
});

_.extend(CartGiftModel.prototype, Backbone.Validation.mixin);
_.extend(
    CartGiftModel.prototype.validation,
    cartGiftValidationMixin
);

var creditCardValidationMixin = {
    cc_name_on_card: {
        required: true,
        msg: validationUtils.getIsRequiredMessageForFieldName('Name on card')
    },
    cc_number: {
        required: true,
        fn: function(value, attr, computedState) {
          if (value == null || value == '') {
            return 'Credit card number is required.'
          } else if (!$.payment.validateCardNumber(value)) {
            return 'Not a valid card number.'
          }
        }
    },
    cc_expiry_date: {
        required: true,
        fn: function(value, attr, computedState) {
          if (value == null || value == '') {
            return 'Expiry date is required.'
          }
          var expiryDateArray = value.split('/');
          if (expiryDateArray.length !== 2) {
            return 'Not a valid expiry date.'
          } else {
            expiryDateArray[0] = expiryDateArray[0].trim();
            expiryDateArray[1] = expiryDateArray[1].trim();
            if (!$.payment.validateCardExpiry(expiryDateArray[0], expiryDateArray[1])) {
             return 'Not a valid expiry date.'
            }
          }
        }
    },
    cc_security_code: {
        required: true,
        fn: function(value, attr, computedState) {
          if (value == null || value == '') {
            return 'Security code is required.'
          } else if (!$.payment.validateCardCVC(value)) {
            return 'Not a valid security code.'
          }
        }
    },
    cc_postal_code: {
      required: true,
      msg: validationUtils.getIsRequiredMessageForFieldName('ZIP / Postal code')
    }
  };

var PaymentCreditCardModel = EntitiesBase.ModelBase.extend({
    constructor: function(attrs, options) {
        EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
    },
    validation: {},
    validationFields: function () {
      var fields = [
          'cc_name_on_card',
          'cc_number',
          'cc_expiry_date',
          'cc_security_code',
          'cc_postal_code'
      ];
      return fields;
    },
    defaults: {
      cc_name_on_card: null,
      cc_number: null,
      cc_expiry_date: null,
      cc_security_code: null,
      cc_postal_code: null,
      cc_card_type: null
    }
});

_.extend(PaymentCreditCardModel.prototype, Backbone.Validation.mixin);
_.extend(
    PaymentCreditCardModel.prototype.validation,
    creditCardValidationMixin
);

var PaymentModel = EntitiesBase.ModelBase.extend({
    constructor: function(attrs, options) {
        EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
    },
    defaults: {
      paymentMethod: 'credit', // credit...
      paymentCreditCardModel: null,
      isGift: false,
      cartGiftModel: null,
      currentOrder: null
    }
});

var cartDeliveryAddressValidationMixin = {
    local_delivery_street_address: {
        required: true,
        msg: validationUtils.getIsRequiredMessageForFieldName('Street Address')
    },
    local_delivery_postal_code: {
        required: true,
        msg: validationUtils.getIsRequiredMessageForFieldName('Postal Code')
    }
  };

var CartDeliveryAddressModel = EntitiesBase.ModelBase.extend({
    constructor: function(attrs, options) {
        EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
    },
    validation: {},
    validationFields: function () {
      var fields = [
          'local_delivery_street_address'
      ];
      return fields;
    },
    defaults: {
      local_delivery_street_address: null,
      local_delivery_apartment_number: null,
      local_delivery_city: null,
      local_delivery_postal_code: null,
      local_delivery_street_address_geocoded_response: null,
      local_delivery_street_address_geocoded_lat: null,
      local_delivery_street_address_geocoded_lon: null,
      local_delivery_street_address_geocoded_state: null,
      local_delivery_street_address_geocoded_postal_code: null,
      local_delivery_street_address_geocoded_country: null,
      local_delivery_street_address_geocoded_city: null,
      local_delivery_street_address_geocoded_street_name: null,
      local_delivery_street_address_geocoded_street_address: null,
      local_delivery_street_address_geocoded_apartment: null,
      local_delivery_street_address_verified: false,
      local_delivery_postal_code_verified: null,
      local_delivery_confirmed_farm_location_slug: null,
      local_delivery_method: null
    }
});

_.extend(CartDeliveryAddressModel.prototype, Backbone.Validation.mixin);
_.extend(
    CartDeliveryAddressModel.prototype.validation,
    cartDeliveryAddressValidationMixin
);

var DeliveryModel = EntitiesBase.ModelBase.extend({
    constructor: function(attrs, options) {
        EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
    },
    defaults: {
      deliveryMethod: 'pickup',
      deliveryTime: null,
      deliveryTimeReadable: null,
      deliveryWindowMinutes: 120,
      deliveryTimeStartUnix: null,
      deliveryTimeEndUnix: null,
      deliveryDate: null,
      deliveryPossibleDays: null,
      deliveryPossibleTimes: null,
      deliveryPossibleTimesLastUpdated: null,
      deliveryAddressModel: null,
      deliveryNotes: null,
      deliveryTipPercentage: null,
      deliveryPhone: null
    }
});

var TipCollection = new Backbone.Collection([
    {
        label: '0%',
        value: 0
    },
    {
        label: '5%',
        value: 0.05
    },
    {
        label: '10%',
        value: 0.10
    },
    {
        label: '15%',
        value: 0.15
    }
])

module.exports = {
    Cart: function () {
      var cart_collection;
      if (lsCache.get(LS_CACHE_CART_ID)) {
        cart_collection = new CartCollection(lsCache.get(LS_CACHE_CART_ID));
      } else {
        cart_collection =  new CartCollection();
      }

      cart_collection.on('add', function(model, collection, options){
        lsCache.set(LS_CACHE_CART_ID, collection.toJSON(), CACHE_TIMEOUT);
      });

      cart_collection.on('remove', function(model, collection, options){
        lsCache.set(LS_CACHE_CART_ID, collection.toJSON(), CACHE_TIMEOUT);
      });
      cart_collection.paymentModel = new PaymentModel();
      cart_collection.paymentModel.set('paymentCreditCardModel', new PaymentCreditCardModel());
      cart_collection.paymentModel.set('cartGiftModel', new CartGiftModel());

      cart_collection.deliveryModel = new DeliveryModel();

      var cartDeliveryAddressModel;

      if (lsCache.get('cartDeliveryAddressModel')) {
        cartDeliveryAddressModel = new CartDeliveryAddressModel(lsCache.get('cartDeliveryAddressModel'));
      } else {
        cartDeliveryAddressModel = new CartDeliveryAddressModel();
      }

      if (cartDeliveryAddressModel.get('local_delivery_method')) {
        cart_collection.deliveryModel.set('deliveryMethod', cartDeliveryAddressModel.get('local_delivery_method'));
      }

      cart_collection.deliveryModel.set('cartDeliveryAddressModel', cartDeliveryAddressModel);

      return cart_collection;
    },
    ClearCart: function () {
      // make cache expire here...
      lsCache.flush();
    },
    TipCollection: TipCollection
};



/** WEBPACK FOOTER **
 ** ./assets/js/entities/cart.js
 **/